export function normalizeToArray(payload, keyCandidates = ['items','data','results','invoices']) {
  try {
    if (Array.isArray(payload)) return payload;

    // common envelopes
    for (const k of keyCandidates) {
      const v = payload?.[k];
      if (Array.isArray(v)) return v;
    }

    // if it looks like a single entity (has id-ish fields), return as-is
    if (payload && typeof payload === 'object' && (payload._id || payload.id || payload.invoiceNumber)) {
      return payload; // DO NOT wrap here; detail endpoints should stay objects
    }

    // fallback: empty array
    return [];
  } catch {
    return [];
  }
}
